//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 교육 및 훈련 - TBM(CUSTOM) 교육현황 (TRA_CUSTOM_01) 전용 로직
 * other 케이스에서 사용
 */

// 교육 및 훈련 - TBM(CUSTOM) 교육현황 인쇄 함수
export const PrintLogic1 = async (
  selectedRowData1,
  dispatch,
  setLoading,
  searchRef
) => {
  // 선택된 행 확인
  if (!selectedRowData1 || selectedRowData1.length === 0) {
    dispatch(
      showSnackbar({
        message: '인쇄할 항목을 선택하세요.',
        type: 'warning',
      })
    );
    return;
  }

  setLoading(true);

  try {
    // 검색 연월 추출 (currentYear, month 사용)
    const currentYear = searchRef?.current?.currentYear;
    const currentMonth = searchRef?.current?.month;
    let year = '';
    let month = '';

    if (currentYear && currentMonth) {
      year = currentYear.toString();
      month = currentMonth.toString();
    } else {
      // 날짜가 없으면 현재 연월 사용
      const now = dayjs();
      year = now.format('YYYY');
      month = now.format('MM');
    }

    // 일자 포맷팅 함수 (YYYY-MM-DD)
    const FormatDate = (dateValue) => {
      if (!dateValue) return '';

      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return '';

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    };

    // 시간 포맷팅 함수 (HH:mm)
    const FormatTime = (dateValue) => {
      if (!dateValue) return '';

      const date = new Date(dateValue);
      if (isNaN(date.getTime())) return '';

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return `${hours}:${minutes}`;
    };

    // 실시 시간(분) 포맷팅 함수 (초를 분으로 변환)
    const FormatDuration = (seconds) => {
      if (!seconds || seconds === 0) return '0분';

      const totalMinutes = Math.floor(Number(seconds) / 60);
      if (totalMinutes <= 0) return '0분';

      const hours = Math.floor(totalMinutes / 60);
      const remainMin = totalMinutes % 60;

      let result = '';
      if (hours > 0) result += `${hours}시간 `;
      if (remainMin > 0) result += `${remainMin}분`;
      return result.trim();
    };

    // 누계시간 포맷팅 함수 (초를 시간/분으로 변환)
    const FormatTotalTime = (seconds) => {
      if (!seconds || seconds === 0) return '0분';

      const totalMinutes = Math.floor(Number(seconds) / 60);
      if (totalMinutes <= 0) return '0분';

      const hours = Math.floor(totalMinutes / 60);
      const remainMin = totalMinutes % 60;

      let result = '';
      if (hours > 0) result += `${hours}시간 `;
      if (remainMin > 0) result += `${remainMin}분`;
      return result.trim();
    };

    const userId = selectedRowData1.userId;

    // SearchLogic2 조회
    const searchResult = await apiRequest(
      'post',
      Global.urls.DocsManagement.getTraCustom01R2,
      {
        Year: Commons.EncryptAES(
          searchRef?.current?.currentYear || dayjs().format('YYYY')
        ),
        Month: Commons.EncryptAES(
          searchRef?.current?.month || dayjs().format('MM')
        ),
        UserId: Commons.EncryptAES(userId || ''),
      }
    );

    const searchData = Commons.InsertNumber(searchResult.data);

    if (searchData && searchData.length > 0) {
      const tableData = searchData.map((row) => ({
        ...row,
        DEP_NM: row.depNm,
        POSITION: row.position,
        NAME: row.name,
        TBM_DATE: FormatDate(row.tbmDate),
        TBM_START_DATE: FormatTime(row.tbmStartDate),
        TBM_END_DATE: FormatTime(row.tbmEndDate),
        TBM_ADD_DATE: FormatDuration(row.tbmAddDate),
        TOTAL_TIME: FormatTotalTime(row.totalTime),
        REMARK: row.remark,
      }));

      // 각 항목마다 별도로 인쇄
      const printData = {
        FileName: 'TRA_CUSTOM_01',
        HeaderData: JSON.stringify({
          YEAR: year,
          MONTH: month,
        }),
        TableData: JSON.stringify(tableData),
      };

      const response = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      // response.data가 blob인 경우 그대로 반환
      if (response.data instanceof Blob) {
        return response.data;
      }
      // response.data가 다른 형태인 경우 blob으로 변환
      else if (response.data) {
        return new Blob([response.data], { type: 'application/pdf' });
      } else {
        console.error('PrintLogic1: 응답 데이터가 없습니다.');
        return null;
      }
    }
  } catch (e) {
    console.log(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
  } finally {
    setLoading(false);
  }
};
